'use client';

import useControlled from '@mui/utils/useControlled';
export default useControlled;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useControlled.js
// module id = 138
// module chunks = 22